/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled from 'styled-components';
import { getTypographyStyles } from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';
import { spacing } from '../../theme';

export const StyledSubMenu = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: 250ms grid-template-rows ease;
  visibility: hidden;
  margin: 0;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    position: relative;
    height: auto;
    overflow: unset;
    margin: var(--spacing-relative-sm) 0 var(--spacing-relative-lg) 0;
    visibility: visible;
  }
`;

export const StyledNavBar = styled.nav<{ $visible?: boolean; $isSecondaryLevel?: boolean }>`
  display: ${(props) => (props.$isSecondaryLevel ? 'none' : 'flex')};
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
  transition: all 0.3s ease;

  border-bottom: ${(props) => props.$isSecondaryLevel && '0'};

  padding-left: ${(props) => props.theme.spacing.sm};
  padding-right: ${(props) => props.theme.spacing.sm};

  padding: ${(props) =>
    props.$isSecondaryLevel ? `0px ${props.theme.spacing.sm} 0px ${props.theme.spacing.sm};` : '0'};

  // hides un-wanted priority nav drop down border arrow
  .background-priority-layer {
    display: none;
    position: absolute;
    top: -1px;
    right: 0;
    width: 100%;
    height: 4px;
    z-index: 1;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
    padding: ${(props) =>
      props.$isSecondaryLevel
        ? `0px var(--spacing-relative-md) var(--spacing-relative-md) var(--spacing-relative-md);`
        : '0'};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    width: 100%;
    max-width: 1920px;
    position: relative;
    display: block;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    position: unset;
    top: unset;
    left: unset;
    width: auto;
    padding-left: 0;
    padding-right: 0;

    transition-timing-function: ${(props) =>
      props.$isSecondaryLevel && props.$visible ? props.theme.easing.duration : '0'};
    transition-duration: ${(props) => props.theme.easing.duration};
    transition-property: transform, opacity, height, visibility;
    opacity: ${(props) =>
      !props.$isSecondaryLevel ? '1' : props.$isSecondaryLevel && props.$visible ? '1' : '0'};
    visibility: ${(props) =>
      !props.$isSecondaryLevel
        ? 'visible'
        : props.$isSecondaryLevel && props.$visible
          ? 'visible'
          : 'hidden'};
    height: ${(props) =>
      !props.$isSecondaryLevel ? '62px' : props.$isSecondaryLevel && props.$visible ? 'auto' : '0'};
    border-bottom: ${(props) => props.$visible && `1px solid ${props.theme.colors.divider}`};

    border-bottom: ${(props) => props.$isSecondaryLevel && 'none'};

    .background-priority-layer {
      display: block;
    }
  }
`;

export const StyledNavList = styled.ul`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  margin: 0;
  padding: 0px;
  list-style: outside none none;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }
`;

export const StyledListItem = styled.li<{
  $hasParentElement?: boolean;
  $isSecondaryLevel?: boolean;
  $isMobile?: boolean;
  $priorityNavLoaded?: boolean;
  $priorityItemslength?: number;
  $hidePriorityDropDown?: boolean;
  $priorityActive?: boolean;
}>`
  margin-left: ${(props) =>
    props.$hasParentElement && !props.$isSecondaryLevel ? props.theme.spacing.sm : '0'};
  margin-right: ${(props) =>
    props.$hasParentElement && !props.$isSecondaryLevel ? props.theme.spacing.sm : '0'};
  padding: 0 ${(props) => props.$isSecondaryLevel && props.theme.spacing.lg};

  display: ${(props) => (props.$isMobile && !props.$hasParentElement ? 'none' : 'block')};

  &.parent-overview {
    margin-left: ${(props) => props.theme.spacing.xs};
    margin-right: ${(props) => props.theme.spacing.xs};
    padding: 0;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}px) {
      margin-left: ${(props) => props.theme.spacing.sm};
      margin-right: ${(props) => props.theme.spacing.sm};
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
      margin-left: ${(props) => props.theme.spacing.md};
      margin-right: ${(props) => props.theme.spacing.md};
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      margin: 0;
      padding-right: ${(props) =>
        props.$isSecondaryLevel ? props.theme.spacing.lg : props.theme.spacing.xl};
    }
  }

  &.parent-item {
    // sub level
    margin-left: ${(props) =>
      props.$hasParentElement && props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.sm}`};
    margin-right: ${(props) =>
      props.$hasParentElement && props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.sm}`};
  }

  &.sub-level-parent {
    display: block;
    // sub level
    margin: 0;
    padding-left: ${(props) =>
      props.$hasParentElement ? props.theme.spacing.lg : props.theme.spacing.xs};
    padding-right: ${(props) =>
      props.$hasParentElement ? props.theme.spacing.lg : props.theme.spacing.xs};

    &:first-child {
      a {
        padding-top: ${(props) => props.theme.spacing.xl};
        padding-left: 0;
      }
    }
  }

  &:last-child label {
    border-bottom: none;
  }

  &#moreMenuList {
    display: none;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    &.parent-item {
      // top level
      margin-left: ${(props) =>
        props.$hasParentElement && !props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.lg}`};
      margin-right: ${(props) =>
        props.$hasParentElement && !props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.lg}`};

      // sub level
      margin-left: ${(props) =>
        props.$hasParentElement && props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.xl}`};
      margin-right: ${(props) =>
        props.$hasParentElement && props.$isSecondaryLevel ? `${spacing.md}` : `${spacing.xl}`};
    }

    margin-left: ${(props) =>
      props.$hasParentElement && !props.$isSecondaryLevel ? `${spacing.xl}` : '0'};
    margin-right: ${(props) =>
      props.$hasParentElement && !props.$isSecondaryLevel ? `${spacing.xl}` : '0'};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
    &.parent-item {
      margin-left: ${(props) => props.theme.spacing.xxl};
      margin-left: ${(props) => props.theme.spacing.xxl};
    }
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    position: relative;
    white-space: nowrap;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
    &:nth-child(1n + 2) {
      padding-block-start: 0;
      padding-inline-end: ${(props) => props.theme.spacing.lg};
    }
    // Add padding to the first element if no parent element is set
    padding-inline-end: ${(props) => (!props.$hasParentElement ? props.theme.spacing.lg : 0)};

    &.parent-item {
      margin-left: 0;
      margin-right: 0;
      padding-left: 0;
      padding-right: 0;
      &:first-child {
        a {
          padding-top: 0;
        }
      }
      padding-right: ${(props) =>
        props.$isSecondaryLevel ? props.theme.spacing.lg : props.theme.spacing.xl};
    }

    &#moreMenuList {
      padding: 0;
      position: ${(props) => (!props.$isSecondaryLevel ? 'absolute' : 'unset')};
      right: ${(props) => (!props.$isSecondaryLevel ? '-10px' : 'unset')};
      width: ${(props) => (!props.$isSecondaryLevel ? '52px' : 'unset')};
      top: 0;
      ${(props) =>
        props.$priorityItemslength && props.$priorityItemslength > 0 && `display : block;`};

      ${(props) =>
        props.$priorityNavLoaded &&
        props.$priorityItemslength &&
        props.$priorityItemslength > 0 &&
        props.$priorityActive &&
        `border-bottom: 2px solid ${process.env.IS_LEGACY ? props.theme.colorsInverted.primary : props.theme.colors.activeIndicator};`};
    }
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.xxl}px) {
    &#moreMenuList {
      right: ${(props) => (!props.$isSecondaryLevel ? '0' : 'unset')};
    }
  }
`;

export const StyledMobileListItem = styled(StyledListItem)<{ $hasParentElement?: boolean }>`
  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const StyledLink = styled.a<{
  $hasParentElement?: boolean;
  $isSecondaryLevel?: boolean;
  $isLastElement?: boolean;
}>`
  display: flex;
  ${(props) => getTypographyStyles(props.theme.typography.copy1)};
  text-decoration: none;
  color: ${(props) => props.theme.colors.text};
  padding-left: ${(props) => props.$hasParentElement && props.theme.spacing.lg};
  padding-right: ${(props) => props.$hasParentElement && props.theme.spacing.lg};
  padding-top: ${(props) => props.theme.spacing.md};
  padding-bottom: ${(props) => props.theme.spacing.md};
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};

  &.secondary-level-link {
    padding-bottom: ${(props) => props.theme.spacing.xs};
    margin-left: 0;
    margin-right: 0;
    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      &:hover {
        color: ${(props) => props.theme.colors.activeLink};
      }
    }
  }

  ${(props) =>
    props.$isLastElement ? 'border-bottom: 0;' : ``}; // remove border from last element

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `margin-left: ${spacing.sm}; margin-right: ${spacing.sm};`
        : `inherit`};
  }
  &:hover {
    color: ${(props) => props.theme.colors.activeLink};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `margin-left: ${spacing.md}; margin-right: ${spacing.md};`
        : `inherit`};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    height: auto;
    line-height: ${(props) => (props.$isSecondaryLevel ? `unset` : '60px')};
    font-size: ${(props) =>
      props.$isSecondaryLevel
        ? props.theme.typography.order2.fontSize
        : props.theme.typography.copy1.fontSize};
    &.secondary-level-link {
      margin-left: 0;
      margin-right: 0;
    }

    &:hover {
      color: ${(props) => props.theme.colors.activeLink};
    }

    &:active {
      color: ${(props) =>
        process.env.IS_LEGACY ? props.theme.colorsInverted.primary : props.theme.colors.activeLink};
    }
  }

  &.parent-link {
    margin-left: 0;
    font-weight: 700;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      ${(props) => getTypographyStyles(props.theme.typography.order3)};
    }
  }

  &.semi-active-link {
    span {
      color: ${(props) => props.theme.colors.activeLink};
    }
  }

  &.active-link {
    color: ${(props) =>
      process.env.IS_LEGACY ? props.theme.colorsInverted.primary : props.theme.colors.activeLink};
    font-weight: 500;
    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      border-bottom: 2px solid
        ${(props) =>
          process.env.IS_LEGACY
            ? props.theme.colorsInverted.primary
            : props.theme.colors.activeIndicator};
      font-weight: normal;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 0;
    margin: 0;
    border-bottom: none;
  }
`;

// Mobile accordion dropdown label
export const StyledTextLabel = styled(StyledLink)`
  width: 100%;
  border-bottom: 0;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

// Parent label for Samelevel and Sublevel lists
export const StyledOverViewLink = styled(StyledLink)<{
  $hasParentElement?: boolean;
  $isSecondaryLevel?: boolean;
  $isActive?: boolean;
  $subPageParent?: boolean;
}>`
  display: flex;
  cursor: pointer;
  ${(props) =>
    getTypographyStyles(
      props.$isSecondaryLevel ? props.theme.typography.order2 : props.theme.typography.parentItem,
    )};
  font-weight: normal;
  font-stretch: normal;
  padding-left: 0;
  padding-right: 0;
  color: ${(props) => (process.env.IS_LEGACY ? props.theme.colors.text : '')};

  ${(props) =>
    props.$isSecondaryLevel && props.$subPageParent
      ? `border-bottom: 2px solid ${props.theme.colorsInverted.primary};`
      : `border-bottom: 1px solid transparent;`};
  ${(props) => props.$hasParentElement && 'margin-top: 0;'};
  height: auto;
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  &.active-link {
    font-weight: 700;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    ${(props) =>
      getTypographyStyles(!props.$isSecondaryLevel && props.theme.typography.parentItemLarge)};
    font-weight: normal;
    font-stretch: normal;
    ${(props) => props.$hasParentElement && !props.$isSecondaryLevel && 'line-height: 60px;'};
    padding-bottom: ${(props) => !props.$hasParentElement && props.theme.spacing.xs};
    padding-left: 0;
    border-bottom: none;

    // hidden border used to help verticle alignment with parent and nav item
    &.active-link {
      font-weight: normal;
      border-bottom: 2px solid
        ${process.env.IS_LEGACY
          ? (props) => props.theme.colorsInverted.primary
          : (props) => props.theme.colors.activeIndicator};
    }
  }

  &:hover {
    color: ${(props) => props.theme.colors.activeLink};
  }

  &:active {
    color: ${(props) => props.theme.colors.activeLink};
  }
`;

export const StyledOverViewLabel = styled(StyledOverViewLink).attrs({ as: 'p' })<{
  $hasParentElement?: boolean;
  $isSecondaryLevel?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${(props) =>
    props.$isSecondaryLevel ? `padding-bottom: ${props.theme.spacing.xs} !important;` : ``}
  border-bottom: 1px solid transparent !important;
  pointer-events: none;
`;

export const StyledMoreDropDown = styled.button<{
  $activePriortyDropDown?: boolean;
  $priorityNavLoaded?: boolean;
}>`
  display: none;
  background: transparent;
  border: none;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: flex;
    width: 100%;
    height: 60px;
    flex-direction: column;
    justify-content: center;
    margin-right: -10px;
    align-items: flex-end;
    cursor: pointer;

    [name='arrow-up'],
    svg {
      color: ${(props) =>
        process.env.IS_LEGACY ? props.theme.colorsInverted.primary : props.theme.colors.icons};
      rotate: 180deg;
      transition: all 0.3s ease;
      border-bottom: 2px solid transparent;
      ${(props) => (props.$activePriortyDropDown ? `rotate: 0deg;` : ``)}
    }
  }
`;

export const StyledOverarchingName = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.primary};
  padding-top: ${(props) => props.theme.spacing.md};
  padding-bottom: ${(props) => props.theme.spacing.md};
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);

  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  cursor: pointer;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const StyledArrowIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  rotate: -180deg;
  transition: all 0.3s ease;
  & svg {
    color: ${(props) =>
      process.env.IS_LEGACY ? props.theme.colorsInverted.primary : props.theme.colors.icons};
  }
`;

export const StyledOverarchingContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: -1;

  p {
    font-size: ${(props) => props.theme.typography.copy1.fontSize};
  }

  span {
    font-size: ${(props) => props.theme.typography.order2.fontSize};
  }
`;

export const StyledSecondaryOverarchingName = styled.label<{ $hasParentElement?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.primary};
  padding-left: ${(props) => props.$hasParentElement && props.theme.spacing.lg};
  padding-right: ${(props) => props.$hasParentElement && props.theme.spacing.lg};
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  ${StyledLink} {
    margin-left: 0;
    margin-right: 0;
  }
  ${(props) =>
    props.$hasParentElement
      ? `margin-left: 0; margin-right: 0;`
      : `margin-left: ${spacing.xs}; margin-right: ${spacing.xs};`};

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `margin-left: ${spacing.sm}; margin-right: ${spacing.sm};`
        : `inherit`};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `margin-left: ${spacing.md}; margin-right: ${spacing.md};`
        : `inherit`};
  }

  cursor: pointer;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;

  &:focus-visible ~ ${StyledOverarchingName}, &:focus-visible ~ ${StyledSecondaryOverarchingName} {
    border: ${(props) => `4px solid ${props.theme.colors.borderFocusColor}`};
    border-radius: ${(props) => props.theme.colors.borderRadius};
  }

  &:checked ~ ${StyledSubMenu} {
    grid-template-rows: 1fr;
    visibility: visible;
  }

  &:checked ~ ${StyledSubMenu} > ${StyledNavBar} {
    padding-top: ${(props) => props.theme.spacing.md};
    padding-bottom: ${(props) => props.theme.spacing.md};
    &.nav-bar-top {
      height: 100vh;
      overflow-y: scroll;
      @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
        height: 62px;
        overflow-y: hidden;
      }
    }
    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &:checked ~ ${StyledSubMenu} > ${StyledNavBar} > ${StyledNavList} {
    &.top-ul-list {
      margin-bottom: 100px;
      @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
        margin-bottom: unset;
      }
    }
  }

  &:checked ~ ${StyledOverarchingName} > ${StyledArrowIcon} {
    rotate: 0deg;
  }

  &:checked ~ ${StyledSecondaryOverarchingName} > ${StyledArrowIcon} {
    rotate: 0deg;
  }
`;

export const StyledSecondLevelSubMenu = styled(StyledSubMenu)<{ $hasParentElement?: boolean }>`
  padding: 0 ${(props) => !props.$hasParentElement && props.theme.spacing.md};
  background: ${(props) => (process.env.IS_LEGACY ? '' : props.theme.colors.mobileSublevelOpened)};
  ${(props) => !props.$hasParentElement && `margin-left: 0; margin-right: 0;`};
  ${StyledListItem} {
    ${(props) => !props.$hasParentElement && `padding: 0;`};
    &.sub-level-parent {
      ${(props) => !props.$hasParentElement && `margin-left: 0; margin-right: 0;`};
      ${StyledLink} {
        ${(props) => !props.$hasParentElement && `padding-left: ${props.theme.spacing.xs};`};
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `padding-left: ${spacing.sm}; padding-right: ${spacing.sm};`
        : `padding: 0;`};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}px) {
    ${(props) =>
      !props.$hasParentElement
        ? `padding-left: ${spacing.md}; padding-right: ${spacing.md};`
        : `padding: 0;`};
  }
  ${StyledLink} {
    padding-top: ${(props) => props.theme.spacing.md};
    padding-bottom: ${(props) => props.theme.spacing.md};
    &.parent-link {
      font-weight: normal;
    }
    &.secondary-level-link {
      ${(props) =>
        !props.$hasParentElement && `padding-left: ${spacing.sm}; padding-right: ${spacing.sm};`}
    }
    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}px) {
      display: none;
    }
  }
`;

export const StyledText = styled(Text)`
  color: ${(props) => (process.env.IS_LEGACY ? '' : props.theme.colors.mobileOverviewText)};
`;
